/*
 *  mhOffCanvas
 *  A quick plugin to generate an off canvas menu that is cloned from main navbar
 *  http://myhermes.co.uk
 *
 *  Made by Mark Cullen
 *  Under MIT License
 */
// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;(function ( $, window, document, undefined ) {

		// undefined is used here as the undefined global variable in ECMAScript 3 is
		// mutable (ie. it can be changed by someone else). undefined isn't really being
		// passed in so we can ensure the value of it is truly undefined. In ES5, undefined
		// can no longer be modified.

		// window and document are passed through as local variable rather than global
		// as this (slightly) quickens the resolution process and can be more efficiently
		// minified (especially when both are regularly referenced in your plugin).

		// Create the defaults once
		var pluginName = "mhOffCanvas",
				defaults = {
				docViewHeight: $(window).height(),
				docViewWidth: $(window).width(),
				menuViewWidth: null,
				menuID: null
		};

		// The actual plugin constructor
		function Plugin ( element, options ) {
				this.element = element;
				// jQuery has an extend method which merges the contents of two or
				// more objects, storing the result in the first object. The first object
				// is generally empty as we don't want to alter the default options for
				// future instances of the plugin
				this.settings = $.extend( {}, defaults, options );
				this._defaults = defaults;
				this._name = pluginName;
				this.init();
		}

		// Avoid Plugin.prototype conflicts
		$.extend(Plugin.prototype, {
				init: function () {
						// Place initialization logic here
						// You already have access to the DOM element and
						// the options via the instance, e.g. this.element
						// and this.settings
						// you can add more functions like the one below and
						// call them like so: this.yourOtherFunction(this.element, this.settings).

                        this.settings.menuViewWidth = this.settings.docViewWidth - $(this.element).width() - 40;
                        this.settings.menuID = $(this.element).attr('id')+'-offcanvas';
												//console.log(this.settings.menuID);
                        $(this.element).attr('data-target', '#'+this.settings.menuID);
                        $(this.element).attr('data-trigger', '#'+$(this.element).attr('id'));
                        $(this.element).settings = this.settings;

                            $('.navbar-offcanvas .offcanvas-dropdown-toggle').on('click', function(e){
                                $('.offcanvas-dropdown').not($(this).parent('li')).removeClass('open');
                                $(this).parent('li').toggleClass('open');
                                e.preventDefault();
                            });

                            $('.navbar-offcanvas .offcanvas-close').on('click', function(e){
                               // let's HIDE the menu
															 //console.log('close offcanvas menu');
                               $('.offcanvas-scrollpane').animate({
                                  scrollTop: 0
                               }, 'fast', function() {
                                fixOffcanvas();
                               });


                               e.preventDefault();
                            });




                        $(this.element).on('click', function(){

                           var dataTarget = $(this).data('target');
                           var dataTrigger = $(this).data('trigger');

                           var docViewHeight = $(window).height();
                           var docViewWidth = $(window).width();
                           var menuViewWidth = docViewWidth - 55;
													 if (menuViewWidth>500) {
														 menuViewWidth = 500 - 55;
													 }

                           if( !$('body').hasClass('offcanvased') ) {

                              // let's SHOW the menu
                              $('body').addClass('offcanvased');
                              $('body').attr('data-target', dataTarget);
                              $('body').attr('data-trigger', dataTrigger);
                              $('body').attr('data-window-height', docViewHeight);
                              $('body').attr('data-window-width', docViewWidth);
                              $('.navbar-offcanvas').css('height', docViewHeight );
                              $('.navbar-offcanvas').css('width', menuViewWidth );
                              $('.offcanvas-scrollpane').css('height', docViewHeight + 150 );
                              $('.offcanvas-scrollpane').css('width', menuViewWidth );


                              $('html, body').animate({scrollTop: 0}, 'fast');

                              if( $('.stuck') ) {
                                $('.stuck').css('opacity', '0');
                              }

                           } else {

                             // let's HIDE the menu
                             fixOffcanvas();

                           }
                        });

                        $(window).on('orientationchange', function() {
														//	console.log('orientation change');
                              fixOffcanvas();

                        });

                        $(window).on('resize', function() {
														//console.log('resize change');
														fixOffcanvas();
                               if( parseInt($(window).width()) != parseInt($('body').attr('data-window-width'))) {
                                    $('body').attr('data-window-width',$(window).width());
                                    fixOffcanvas();
                               }

                        });

				}
		});

		// A really lightweight plugin wrapper around the constructor,
		// preventing against multiple instantiations
		$.fn[ pluginName ] = function ( options ) {
				this.each(function() {
						if ( !$.data( this, "plugin_" + pluginName ) ) {
								$.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
						}
				});

				// chain jQuery functions
				return this;
		};

})( jQuery, window, document );


function css(a) {
    var sheets = document.styleSheets, o = {};
    for (var i in sheets) {
        var rules = sheets[i].rules || sheets[i].cssRules;
        for (var r in rules) {
            if (a.is(rules[r].selectorText)) {
                o = $.extend(o, css2json(rules[r].style), css2json(a.attr('style')));
            }
        }
    }
    return o;
}

function css2json(css) {
    var s = {};
    if (!css) return s;
    if (css instanceof CSSStyleDeclaration) {
        for (var i in css) {
            if ((css[i]).toLowerCase) {
                s[(css[i]).toLowerCase()] = (css[css[i]]);
            }
        }
    } else if (typeof css == "string") {
        css = css.split("; ");
        for (var i in css) {
            var l = css[i].split(": ");
            s[l[0].toLowerCase()] = (l[1]);
        }
    }
    return s;
}

function fixOffcanvas() {
    //console.log('fix the menu ('+$(window).height()+')');
    var dataTarget = $('body').data('target');
    var dataTrigger = $('body').data('trigger');
    var docViewHeight = $(window).height();
    var docViewWidth = $(window).width();
    var menuViewWidth = docViewWidth - $(dataTrigger).width() - 40;
		if (menuViewWidth>500) {
			menuViewWidth = 500 - 55;
		}
		$('.navbar-offcanvas').css('width', menuViewWidth );
		$('.offcanvas-scrollpane').css('width', menuViewWidth );

    $('body').removeClass('offcanvased');
    $('body').attr('data-target', '');
    $('body').attr('data-trigger', '');
    $('.offcanvas-dropdown').removeClass('open');

    if( $('.stuck') ) {

         $('.stuck').css('opacity', '1');
    }
}
